import React from 'react';
import PropTypes from 'prop-types';
import { Form, reduxForm } from 'redux-form';

import { TextField, Button, Paper, Translation } from '../../common';
import { connectTo } from '../../../utils';

const LoginForm = ({
  styles,
  translations,
  handleSubmit,
  LogoComponent: Logo,
}) => (
  <Paper className={styles['login-form__wrapper']}>
    <Form className={styles['login-form__form']} onSubmit={handleSubmit}>
      <Logo />
      <TextField
        name="username"
        required
        placeholder={translations['LOGIN']}
        className={styles['login-form__form-text-field']}
      />
      <TextField
        name="password"
        type="password"
        required
        placeholder={translations['PASSWORD']}
        className={styles['login-form__form-text-field']}
      />
      <Button
        id="page.login.component.login-form.login-button"
        type="submit"
        className={styles['login-form__form-button']}
      >
        <Translation>LOGIN</Translation>
      </Button>
      {/* <Checkbox
        id="page.login.component.login-form.remember-checkbox"
        name="shouldMember"
        label="Angemeldet bleiben"
        hasForm
      />
      <hr className={styles['login-form__form-horizontal-rule']} />
      <a
        className={styles['login-form__form-forgot-password']}
        href="https://example.com"
      >
        Passwort vergessen?
      </a> */}
    </Form>
  </Paper>
);

LoginForm.propTypes = {
  styles: PropTypes.object,
  onSubmit: PropTypes.func,
  LogoComponent: PropTypes.any,
};

const LoginReduxForm = reduxForm({ form: 'login' })(LoginForm);

export default connectTo(
  ({ translations: { translations } }) => ({ translations }),
  {},
  LoginReduxForm
);
